module.exports = __webpack_public_path__ + "static/media/search_icon--blue.d5f79511.svg";